import { useEffect, useState } from "react";

/**
 * useDelayedLoading
 *
 * Returns a delayed version of the loading state to prevent flashing loaders
 * for fast operations. The loader will only show if loading takes longer than
 * the specified delay.
 *
 * @param isLoading - The actual loading state
 * @param delay - Delay in milliseconds before showing loader (default: 300ms)
 * @returns Delayed loading state
 */
export function useDelayedLoading(isLoading: boolean, delay = 300): boolean {
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if (isLoading) {
      const timer = setTimeout(() => {
        setShowLoading(true);
      }, delay);

      return () => clearTimeout(timer);
    }

    setShowLoading(false);
  }, [isLoading, delay]);

  return showLoading;
}
